import AnonFeatureGuard from '@/components/guards/AnonFeatureGuard'
import StandaloneAgencyDocumentByIdPage from '@/standalone-reference-viewer/agency/StandaloneAgencyDocumentByIdPage'
import StandaloneReferenceViewerCaseLawPage from '@/standalone-reference-viewer/caselaw/views/StandaloneReferenceViewerCaseLawPage'
import StandaloneReferenceViewerLrrPage from '@/standalone-reference-viewer/lrr/views/StandaloneReferenceViewerLrrPage'
import { kRouteSegments } from '@/routing/paths'
import type { RouteFactory } from '../types'

/**
 * Creates the matter-free standalone source viewers (caselaw, LRR, and government documents opened
 * by document ID). Matter-scoped versions live under MatterLayout in referenceViewer.tsx.
 *
 * These routes must stay: the MCP connector's sign-in source links point at them
 * (services/paxton-mcp-connector/src/paxton_mcp/source_links.py), and in-app links built without a
 * matter, such as citator lists, open them too.
 */
export const createContentViewerRoutes: RouteFactory = () => [
  {
    path: `${kRouteSegments.referenceViewer}/caselaw/:idType?/:id`,
    element: (
      <AnonFeatureGuard showAuthOnGuard={true}>
        <StandaloneReferenceViewerCaseLawPage />
      </AnonFeatureGuard>
    ),
  },
  {
    path: `${kRouteSegments.referenceViewer}/lrr/:s3Path`,
    element: (
      <AnonFeatureGuard showAuthOnGuard={true}>
        <StandaloneReferenceViewerLrrPage />
      </AnonFeatureGuard>
    ),
  },
  {
    path: `${kRouteSegments.referenceViewer}/agency-document/:documentId`,
    element: (
      <AnonFeatureGuard showAuthOnGuard={true}>
        <StandaloneAgencyDocumentByIdPage />
      </AnonFeatureGuard>
    ),
  },
]
